import styled from 'styled-components';
import Slider from '@rsos/components/capstone/base/Slider';

interface StyledSliderProps {
  value: number;
}

export const StyledSlider = styled(Slider)<StyledSliderProps>`
  width: 100%;
  --min: 0;
  --max: 100;
  --val: ${({ value }) => value};
`;
